import { render, staticRenderFns } from "./CompanySdsTable.vue?vue&type=template&id=2b5c6bc4&scoped=true"
import script from "./CompanySdsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySdsTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanySdsTable.vue?vue&type=style&index=0&id=2b5c6bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c6bc4",
  null
  
)

export default component.exports